// @flow

// Selectors
import users$ from './selectors/users'
import tableState$ from './selectors/tableState'

// DataTable Compose
import composeUsersDataTable from 'fc-datatable-users'

export default composeUsersDataTable({
  users$,
  tableState$,
})
